import type { FeedState } from './feeds';
import type { Fixture, FixturesFeed } from './types';

/** A calendar reminder must come from a current, authorised, confirmed fixture. */
export function canDownloadMatchdayCalendar(fixture: Fixture, fixtures: FeedState<FixturesFeed>, now = Date.now()): boolean {
  return !fixtures.stale && !fixtures.data.provisional && fixtures.data.source?.status !== 'degraded' &&
    ['approved', 'licensed'].includes(fixtures.data.source?.rights ?? '') &&
    fixture.status === 'scheduled' && fixture.statusQuality !== 'overdue' && !fixture.timeTbc &&
    Boolean(fixture.kickoffUtc && Number.isFinite(Date.parse(fixture.kickoffUtc))) && Date.parse(fixture.kickoffUtc!) > now;
}
